import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

/**
 * Class name joiner.
 *
 * `clsx` handles the conditional/array/object forms, `tailwind-merge` resolves
 * the conflicts that come from a component's base classes meeting a caller's
 * `className` override (e.g. base `px-3` vs caller `px-0`). Everything in this
 * UI leans on `className` passthrough, so this is the single place that decides
 * who wins.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs))
}

export type { ClassValue }
